import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import loadGeoraster, { carbonColorFn } from './loadGeoraster';

export default function UoHRasterLayer({ url, opacity = 0.75, onStats }) {
  const map = useMap();
  const layerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (layerRef.current) { map.removeLayer(layerRef.current); layerRef.current = null; }
      if (!url) return;
      try {
        await loadGeoraster();
        const res = await fetch(url);
        const buf = await res.arrayBuffer();
        const georaster = await window.parseGeoraster(buf);
        if (cancelled) return;

        const pixels = georaster.values?.[0];
        if (pixels && onStats) {
          let sum = 0; let count = 0;
          pixels.forEach(row => row.forEach(v => {
            if (v != null && isFinite(v) && v !== georaster.noDataValue) { sum += v; count++; }
          }));
          const pixelHa = 0.01;
          const totalTons = sum * pixelHa;
          onStats({ totalTons, pixelCount: count, min: georaster.mins?.[0], max: georaster.maxs?.[0] });
        }

        const layer = new window.GeoRasterLayer({
          georaster,
          opacity,
          pixelValuesToColorFn: carbonColorFn(georaster),
          resolution: 256,
        });
        if (cancelled) return;
        layer.addTo(map);
        layerRef.current = layer;
        try {
          map.fitBounds([
            [georaster.ymin, georaster.xmin],
            [georaster.ymax, georaster.xmax],
          ]);
        } catch (_) {}
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[UoHRasterLayer]', e);
      }
    })();
    return () => { cancelled = true; if (layerRef.current) { map.removeLayer(layerRef.current); layerRef.current = null; } };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, map]);

  useEffect(() => {
    if (layerRef.current) layerRef.current.setOpacity(opacity);
  }, [opacity]);

  return null;
}
